import { render } from "./WelcomeVdhPartnerContent.vue?vue&type=template&id=66c85d18&scoped=true"
import script from "./WelcomeVdhPartnerContent.vue?vue&type=script&lang=js"
export * from "./WelcomeVdhPartnerContent.vue?vue&type=script&lang=js"

import "./WelcomeVdhPartnerContent.vue?vue&type=style&index=0&id=66c85d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c85d18"]])

export default __exports__